import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import $store from '@/store'
import { validateMBL } from '@/api/AirExport/airExportJob'
import { EstimateProfitUtil } from '@/class/cargo/model/utils/EstimateProfitUtil'
import { CreditControlUtil } from '@/class/cargo/model/utils/CreditControlUtil'
import { Company } from '@/class/model/mdm/Company'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
export class VerifyWorkspacePM {
  /**
  * @param {Object} view 视图
  */
  constructor(view) {
    this.view = view
    this.$message = view.$message
    this.$confirm = view.$confirm
    this.chargeAccountIdObject = null
    this.checkEstimate = false
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get currentRow() {
    return this.view.currentRow
  }
  set currentRow(currentRow) {
    this.view.currentRow = currentRow
  }
  get paramsOfTab() {
    return this.view.paramsOfTab
  }
  set paramsOfTab(paramsOfTab) {
    this.view.paramsOfTab = paramsOfTab
  }
  /**
   * 在保存前进行校验
   */
  async checkBeforeSave(bodyJob) {
    const job = this.paramsOfTab
    // 业务规则：DDP业务类型时，尾程商务负责人必填
    if (job && this.isCustomJobTypeDDP(job) && !job.userDefinedRoleId6) {
      // 引导用户回到"基本"页签填写
      if (this.view && ('activeTabName' in this.view)) {
        this.view.activeTabName = job.masterFlag ? 'masterBasicTab' : 'basicTab'
      }
      this.$message.warning(this.view.$t('Message.FieldValueCannotBeNull', [this.view.$t('CargoMsg.Cargo_LastMileBusinessLeader')]))
      return false
    }
    // 中邮委托单位是否黑名单
    const blacklist = await JobUtils.checkBlacklistByCustomerId(job.customerId, !(job.uuid && job.customerId === this.currentRow.customerId))
    if (blacklist) {
      if (!job.uuid || (job.uuid && job.customerId !== this.currentRow.customerId)) {
        return false
      }
    }
    const reqInputCharge = Number(this.config.get('saveCharge')) === 1
    const isBookingFeeMandatoryAppliedGlobally = Number(this.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
    if (!(job.lclMasterUuid && !job.uuid) && !SecurityUtil.checkSaveCharge(reqInputCharge, job, isBookingFeeMandatoryAppliedGlobally)) {
      return false
    }
    let flag = await this.backEndValidateStep(bodyJob)
    if (!flag) {
      return false
    }
    flag = await CreditControlUtil.checkCreditBlack(job, !blacklist, this.currentRow)
    if (!flag) {
      return false
    }
    flag = await this.checkChargeAccountId()
    if (!flag) {
      return false
    }
    const needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
    // needConfirmProjectNo【是否要验证项目编号重复】; openProjectConfig【是否开启项目管理】
    if (job.poNo && needConfirmProjectNo && Number(this.config.get('openProjectConfig')) === 0) {
      flag = await JobUtils.isPoNoExist(job.poNo, job.uuid)
      if (!flag) {
        return false
      }
    }
    return true
  }

  // 自定义业务类型为 DDP 时，需要填写尾程商务负责人
  isCustomJobTypeDDP(job) {
    const code = job && job.customJobType
    if (!code) return false
    // 检查是否为DDP相关业务类型
    return code === 'DDP' || code === 'EDDP' || code === 'REDDP' || code === 'RIDDP'
  }
  // 后台验证字段
  async backEndValidateStep(bodyJob) {
    const job = this.paramsOfTab
    const fields = {}
    if (job.mbl && job.mbl.length > 0 && !job.lclMasterUuid) {
      fields['mbl'] = job.mbl
    }
    let flag = true
    if (fields.hasOwnProperty('mbl') && fields['mbl']) {
      const body = {
        branchId: $store.getters.currentOfficeId,
        jobKey: job.uuid,
        fieldMap: fields
      }
      await validateMBL(body).then(async res => {
        if (res.data && res.data['field']) {
          switch (res.data['field']) {
            case 'mbl':
              this.view.$message.warning(this.view.$t('queryJob.PrimaryDocNoAlreadyExists'))
              flag = false
              break
            default : break
          }
        } else {
          const reqInputCharge = Number(this.config.get('saveCharge')) === 1
          if (reqInputCharge) {
            this.checkEstimate = await EstimateProfitUtil.checkEstimate(job, params => {
              let resolveRef = null
              const result = new Promise(resolve => {
                resolveRef = resolve
              })
              const dialog = this.view.estimateValidationDialog
              dialog.job = params.job
              dialog.estimateProfitRate = params.estimateProfitRate
              dialog.tatolProfit = params.tatolProfit
              dialog.callback = isSave => {
                resolveRef(isSave)
              }
              dialog.visible = true
              return result
            })
            if (bodyJob) {
              bodyJob.estimateAccountsReceivable = job.estimateAccountsReceivable
              bodyJob.estimateAccountsPayable = job.estimateAccountsPayable
              bodyJob.estimateAccountsPayable = job.estimateAccountsPayable
              bodyJob.situation = job.situation
            }
            if (!this.checkEstimate) {
              flag = false
            } else {
              flag = true
            }
          }
        }
      })
    }
    return flag
  }
  // 验证费 输入
  async checkChargeAccountId() {
    const job = this.paramsOfTab
    let messageTitle = ''
    let company = null
    if (job.charges && job.charges.length > 0) {
      for (const charge of job.charges) {
        if (charge.accountId > 0) {
          company = await Company.getCompanyById(charge.accountId)
          if (company && !company.active) {
            if (!this.chargeAccountIdObject || !this.chargeAccountIdObject[company.uuid]) {
              if (company.chineseName) {
                messageTitle = this.view.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.chineseName)
              } else {
                messageTitle = this.view.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.englishName)
              }
              break
            }
          }
        }
      }
    }
    if (messageTitle) {
      return await this.$confirm(messageTitle, this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        type: 'info'
      }).then(() => {
        this.chargeAccountIdObject = this.chargeAccountIdObject || {}
        this.chargeAccountIdObject[company.uuid] = company.uuid
        return true
      }).catch(() => false)
    } else {
      return true
    }
  }
}
